import { getLocationList, switchAccountLocation } from "../../../../services/admin/organization";

// The selection a reviewer made before an account switch, restored after the
// reload (see SessionSelect).
export const PENDING_SELECTION_KEY = "reading-review/pending-selection";

// SCRUM-845: picking locations in another account makes that account the
// app's current one - the patient card, notes, AI insights and Patient
// Details all read the current account from session storage. Same steps as
// the header's Switch Account (AccountLocationSwitcher.handleAccountSwitch),
// except it lands back on My Tasks › Readings Review with the chosen
// locations preselected instead of on the Dashboard. Throws a user-facing
// message on failure, after rolling the stored account back.
export async function switchAccountForReview(account, locationIds, queryClient, caseManagerId) {
  const saved = {
    user: localStorage.getItem("user"),
    accId: sessionStorage.getItem("acc_id"),
    accName: sessionStorage.getItem("acc_name"),
    schema: sessionStorage.getItem("schema_name"),
    currentLoc: sessionStorage.getItem("current_loc"),
    fallbackLocation: localStorage.getItem("fallback_location"),
    fallbackOrg: localStorage.getItem("fallback_org"),
  };
  const rollback = () => {
    if (saved.user) localStorage.setItem("user", saved.user);
    if (saved.accId) sessionStorage.setItem("acc_id", saved.accId);
    if (saved.accName) sessionStorage.setItem("acc_name", saved.accName);
    if (saved.schema) sessionStorage.setItem("schema_name", saved.schema);
    if (saved.currentLoc) sessionStorage.setItem("current_loc", saved.currentLoc);
    if (saved.fallbackLocation) localStorage.setItem("fallback_location", saved.fallbackLocation);
    if (saved.fallbackOrg) localStorage.setItem("fallback_org", saved.fallbackOrg);
  };

  try {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      user.current_account = account.id;
      user.current_location = null;
      user.current_schema = account.schema_name;
      localStorage.setItem("user", JSON.stringify(user));
    }
    sessionStorage.setItem("acc_id", account.id);
    sessionStorage.setItem("acc_name", account.name || "");
    sessionStorage.setItem("schema_name", account.schema_name);
    sessionStorage.removeItem("current_loc");
    localStorage.removeItem("fallback_location");
    localStorage.setItem("fallback_org", JSON.stringify(account));

    const { locations = [] } = (await getLocationList(true)) || {};
    // Make the first chosen location the app's current one.
    const chosen = locations.find((loc) => String(loc.id) === String(locationIds[0]));
    if (chosen) {
      sessionStorage.setItem("current_loc", JSON.stringify(chosen));
      localStorage.setItem("fallback_location", JSON.stringify(chosen));
    }
    const current = JSON.parse(sessionStorage.getItem("current_loc") || "null");
    if (!current?.id) throw new Error("This account has no locations configured.");

    await switchAccountLocation({ account_id: account.id, location_id: String(current.id) });
  } catch (error) {
    rollback();
    const status = error?.response?.status;
    if (status === 401 || status === 403) throw new Error("You don't have access to this account.");
    throw new Error(
      error?.response?.data?.error || error?.message || "Failed to switch account. Please try again."
    );
  }

  sessionStorage.setItem(
    PENDING_SELECTION_KEY,
    JSON.stringify({
      accId: String(account.id),
      locationIds: locationIds.map(String),
      caseManagerId: caseManagerId ? String(caseManagerId) : null,
    })
  );
  sessionStorage.setItem("my-tasks/active-tab", "dailies");
  queryClient?.clear();
  window.location.href = "/my-tasks";
}
